import { Component, OnInit } from '@angular/core';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';
import { AppSettings } from 'app/modules/shared/app.settings';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss'],
})
export class TermsConditionsComponent implements OnInit {
  langaugeOptions: any[] = [];
  selectedLangauge: any = AppSettings.DEFAULT_LANGUAGE;
  showLanguageDropdown: boolean = false;
  termsConditionsData: any;

  constructor(
    private commonBindingDataService: CommonBindingDataService,
  ) {}

  ngOnInit() {
    this.commonBindingDataService.getLanguageSettings().subscribe((result) => {
      this.termsConditionsData = result;
      const isLanguageSupport =
        this.termsConditionsData?.isLanguageSupport === true || this.termsConditionsData?.isLanguageSupport === 'true';

      const supportedLanguages = (this.termsConditionsData?.supportedLanguages ?? '').toString();
      this.langaugeOptions = supportedLanguages
        .split(',')
        .map((c) => c.trim().toLowerCase())
        .filter((c) => c)
        .map((code) => ({ label: AppSettings.LANGUAGE_LABELS[code] ?? code, value: code }));

      const defaultLanguage = (this.termsConditionsData?.defaultLanguage ?? AppSettings.DEFAULT_LANGUAGE).toString().trim().toLowerCase();
      const supportedLanguageCodes = this.langaugeOptions.map((opt) => opt.value);
      this.selectedLangauge = supportedLanguageCodes.includes(defaultLanguage) ? defaultLanguage : (supportedLanguageCodes[0] ?? defaultLanguage);

      this.showLanguageDropdown = isLanguageSupport && this.langaugeOptions.length > 0;
    }, (reason) => {
      console.log(reason);
    });

  }
}
